import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Util from '../../services/Util';
import './FileDescriptor.css';

var FileDescriptor = /*#__PURE__*/function (_Component) {
  _inherits(FileDescriptor, _Component);

  function FileDescriptor() {
    _classCallCheck(this, FileDescriptor);

    return _possibleConstructorReturn(this, _getPrototypeOf(FileDescriptor).apply(this, arguments));
  }

  _createClass(FileDescriptor, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$file = _this$props.file,
          file = _this$props$file === void 0 ? {} : _this$props$file,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? file.name : _this$props$name,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? file.size : _this$props$size,
          onClick = _this$props.onClick,
          onDelete = _this$props.onDelete,
          disabled = _this$props.disabled;
      var disabledClass = disabled ? ' disabled' : '';
      var downloadClass = !disabled && onClick ? ' downloadable' : '';
      return React.createElement('div', {
        className: 'FileDescriptor',
        notranslate: 'true'
      }, React.createElement('i', {
        className: 'icon-ic_file FileDescriptor-file-icon' + disabledClass
      }), name && React.createElement('span', {
        className: 'FileDescriptor-file-name' + disabledClass + downloadClass,
        onClick: disabled ? null : onClick
      }, name), size && React.createElement('span', {
        className: 'FileDescriptor-file-size'
      }, Util.getFileSize(size)), onDelete && React.createElement('i', {
        className: 'icon-ic_close FileDescriptor-btn-delete',
        onClick: disabled ? null : onDelete
      }));
    }
  }]);

  return FileDescriptor;
}(Component);

FileDescriptor.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  name: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  disabled: PropTypes.bool
};
FileDescriptor.defaultProps = {
  disabled: false
};
export default FileDescriptor;